import { useState, useEffect, useRef } from "react";
import { Formik, Form } from "formik";
import * as yup from "yup";
import LockIcon from "@mui/icons-material/Lock";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { YSButton } from "../../../uikit/YSButton";
import { Box } from "@mui/system";
import { v4 as uuid } from "uuid";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import RadioGroup from "@mui/material/RadioGroup";
import {
  blackColor,
  BtnGroupStyle,
  DRxCheckboxStyle,
  DRxInputStyle,
  DRxSelectStyle,
  DRxTextareaStyle,
  NoteToggleStyle,
  warnColor,
  HtmlTooltip,
  BenefitsBtnStyle,
  RxPadBox,
  DataGridListStyle,
  LgCardStyle,
  SingleConfirmCard,
  DatePickerField,
  InputSMBoxStyle,
  primaryColor,
} from "../../../Theme";
import PatientBenefitIcon from "../../../images/icons/PatientBenefitIcon.png";
import TimeIcon from "../../../images/icons/TimeIcon.svg";
import PatientBenefitsCheckIcon from "../../../images/icons/PatientBenefitsCheckIcon.svg";
import InfoIcon from "../../../images/icons/InfoIcon.svg";
import PreferredPharmacyIcon from "../../../images/icons/rxpad/PreferredPharmacy.svg";
import HeartIcon from "../../../images/icons/HeartIcon.svg";
import { DialogPopup } from "../../../components/DialogPopup";
import DrugDataList from "../../../components/DrugDataList";
import YSCheckBox from "../../../uikit/YSCheckBox";
import TimeList from "../../../components/TimeList";
import PharmacyDataList from "../../PharmacyDataList";
import { TextClick } from "../../../components/Content";
import DRxSelect from "../../../uikit/DRxSelect";
import DRxInput from "../../../uikit/DRxInput";
import { DRxSelect2 } from "../../../uikit/DRxSelect2";
import DRxTextarea from "../../../uikit/DRxTextarea";
import FavoritePharmacyDataList from "../../../components/FavoritePharmacyDataList";
import PatientBenefitsCheck from "../../../components/PatientBenefitCheck";
import SearchIcon from "../../../images/icons/SearchIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { loadingDrugSearchAjax } from "../../../Redux/Slice/DrugSearchAjaxSlice";
import { YSSelectSearch } from "../../../uikit/YSSelectSearch";
import {
  refreshDrugInfo,
  ChangeDrug,
  updatePatientEmail,
} from "../../../Apis/AuthApiServices";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import NoRecords from "../../../components/NoRecords";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import { TextField } from "@mui/material";
import StepMedicationsList from "../../../components/StepMedicationsList";
import { addDays, addYears } from "date-fns";
import YSSnackBar from "../../../uikit/YSSnackBar";
import { loadingPrescriberDetails } from "../../../Redux/Slice/PrescriberDetailsSlice";
import { loadingPatientDetails } from "../../../Redux/Slice/PatientDetailsSlice";
import { useOnBehalfContext } from "../../../context/OnbehalfContext";
import useDebounce from "../../../CustomHooks/useDebounce";
import { disableClinic } from "../../../Redux/Slice/ClinicDisableSlice";
import WarningIcon from "../../../images/icons/WarningIcon.svg";

const initialStateRxPad = {
  drugResourceLinkOptions: [],
  addToFavoriteDrugs: "",
  substitutionCode: null,
  sigDeliveryId: "",
  sigDeliveryOptions: null,
  sigDoseId: "",
  sigDoseOptions: null,
  sigDoseUnitsId: "",
  sigDoseUnitsOptions: null,
  sigFreqId: "",
  stepMedicationsList: null,
  sigFreqOptions: null,
  sigTimeMorning: "",
  controlledSubstance: null,
  sigTimeNoon: "",
  sigTimeEvening: "",
  sigTimeNight: "",
  sigTimeBedTime: "",
  sigTimeBeforeMeals: "",
  sigTimeAfterMeals: "",
  drugTypeOptionsDisableFlag: false,
  pharmacyEditDisableFlag: false,
  sigTimeBeforeBed: "",
  sigDrugNameRouteStrengthOptions: null,
  xdeaNumber: "",
  deaClassCode: "",
  stepMedicationDrugFalg: "",
  doctorNote: "",
  refillsDisableFlag: null,
  sigFreeText: "",
  prescriptionType: "",
  priorAuthorization: null,
  priorityIndicator: null,
  postDatedPrescription: null,
  postDatedPrescriptionDate: null,
  copay: "",
  coverage: "",
  drugType: "",
  hiddenDrugName: "",
  drugName: "",
  drugId: "",
  drugDescription: "",
  dosageForm: "",
  strength: "",
  strengthUnit: "",
  formularyStatus: "",
  sig: "",
  route: "",
  daysSupply: "",
  quantity: "",
  qtyQualifier: "",
  refills: "",
  instructions: "",
  doctorInstructions: "",
  type: null,
  patientId: "",
  doctorId: "",
  ePAFlag: "",
  epcsQueued: false,
  qtyQualifiersOptions: [],
  typesOptions: null,
  wcxfrIndicatorOptions: null,
  substitutionCodeOptions: null,
  drugsOptions: null,
  rxhubPBMUniqueIdOptions: [],
  userId: "",
  practiceId: "",
  pharmacyBenifits: "",
  benifitFlag: "",
  rxNumber: 1,
  medicationHistoryId: null,
  savedPrescriptionId: null,
  favoriteDrugId: null,
  practiceFavoriteDrugId: null,
  dispensibleDrugId: 0,
  rxOtcCode: null,
  formularyStatusCode: "",
  diagnosisIcd: null,
  diagnosisIcdOptions: null,
  pharacyCode: null,
  rxhubPBMUniqueId: "",
  initQtyQualifierListFlag: null,
  packSizeUnitCode: "",
  packDescCode: "",
  ndc: "",
  therapAltDrugsFlag: "",
  narcoticDrugFlag: false,
  allAlternativesList: null,
  drugResourceLink: [],
  payerAltdrugfalg: "",
  rtfAlternativeDrugsInfo: null,
  drugResourceLinks: "",
  healthPlanId: "",
  healthPlanGroupId: "",
  pbmParticipantId: "",
  rxDate: null,
  dailyMaxDose: "",
  drugInformation: "",
  pharmacyName: "",
  pharmacyFaxNumber: "",
  pharmacyCode: "",
  prescriptionCoverageMap: "",
};

export default function RxForm(props: any) {
  const { panel, getPopulateData, tabListLength } = props;
  const [drugNameState, setDrugNameState] = useState("");
  const drugNameDebounce = useDebounce(drugNameState, 1000);
  const dispatch = useDispatch();
  const DrugSearchAjaxState = useSelector((state: any) => {
    return { ...state.DrugSearchAjaxSlice };
  }); //redux data
  const AllDropdwonsState = useSelector((state: any) => {
    return { ...state?.GlobalDropdownSlice?.DropdownLists };
  }); //redux data
  const pharmacyHisDropDown = useSelector((state: any) => {
    return { ...state?.PharmacyDropDownSlice };
  }); //redux data
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const PrescriberDetailsState = useSelector((state: any) => {
    return { ...state?.PrescriberDetailsSlice };
  }); //redux data

  const { onBehalfContext }: any = useOnBehalfContext();

  const pharmacyCodeRef = useRef<HTMLDivElement>(null);

  const [pharmacyCodeOptionClass, setPharmacyCodeOptionClass] = useState("");
  const [data, setData] = useState<any>(initialStateRxPad);
  const [formErrors, setFormErrors] = useState<{} | null>(null);
  const doctorId: any = localStorage.getItem("doctorId");
  const patientId: any = sessionStorage.getItem("patientId");
  const loginId: any = localStorage.getItem("LoginUserID") ?? "";
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const maxDate = addYears(addDays(new Date(), 1), 1);
  const [StateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  const [emailUpdatePopup, emailUpdateSetPopup] = useState(false);
  const handleShowEmailUpdatePopupClick = () => {
    emailUpdateSetPopup(true);
  };
  const handleHideEmailUpdatePopupClick = () => {
    emailUpdateSetPopup(false);
  };
  const handlepharmacyCodeRefClick = () => {
    pharmacyCodeRef.current !== null &&
      pharmacyCodeRef.current.classList.remove("yellow");
  };

  const getEPCSControlSubstance = (values: any, value?: any) => {
    if (value) {
      let currentSelectedPharmacyDetails =
        pharmacyHisDropDown?.PharmacyDropDownData?.find(
          (each: any) => each?.pharmacyCode === value
        );
      return currentSelectedPharmacyDetails?.epcsEnabled;
    } else {
      let currentSelectedPharmacyDetails =
        pharmacyHisDropDown?.PharmacyDropDownData?.find(
          (each: any) => each?.pharmacyCode === values.pharmacyCode
        );
      return currentSelectedPharmacyDetails?.epcsEnabled;
    }
  };

  const getLabels = (formProps: any) => {
    const { values } = formProps;
    let timelabels = "";
    if (values.sigTimeMorning === "ON") timelabels = timelabels + " at morning";
    if (values.sigTimeNight === "ON") timelabels = timelabels + " at night";
    if (values.sigTimeAfterMeals === "ON")
      timelabels = timelabels + " at after meals";
    if (values.sigTimeBedTime === "ON") timelabels = timelabels + " at bedtime";
    if (values.sigTimeNoon === "ON") timelabels = timelabels + " at noon";
    if (values.sigTimeBeforeBed === "ON")
      timelabels = timelabels + " at before bed";
    if (values.sigTimeBeforeMeals === "ON")
      timelabels = timelabels + " at before meals";
    if (values.sigTimeEvening === "ON") timelabels = timelabels + " at evening";
    let currentDelivery = AllDropdwonsState?.sigDeliveryOptions?.find(
      (each: any) => each?.sfid == values.sigDeliveryId
    );
    let currentDose = AllDropdwonsState?.sigDoseOptions?.find(
      (each: any) => each?.sfid == values.sigDoseId
    );
    let currentUnits = AllDropdwonsState?.sigDoseUnitsOptions?.find(
      (each: any) => each?.sfid == values.sigDoseUnitsId
    );
    let currentFreq = AllDropdwonsState?.sigFreqOptions?.find(
      (each: any) => each?.sfid == values.sigFreqId
    );

    return `${currentDelivery?.name ?? ""} ${currentDose?.name ?? ""} ${
      currentUnits?.name ?? ""
    } ${currentFreq?.name ?? ""} ${timelabels ?? ""}`;
  };

  const benefitRefresh = async (props: any, latest: any) => {
    let formValues = props;
    props.rxhubPBMUniqueId = latest;
    formValues = {
      prescriptionForm: formValues,
      patientId: patientId,
      userDetails: {
        userId: loginId,
        doctorId: doctorId,
        onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
        selectedClinicId: sessionStorage.getItem("clinicId") ?? "",
      },
    };
    try {
      setLoading(true);
      const refreshResult = await refreshDrugInfo(formValues);
      if (refreshResult?.data?.digitalRxStatusCode === 200) {
        setData(refreshResult?.data?.response[0]?.prescriptionForm);
        let tabs: any = JSON.parse(sessionStorage.getItem("rxTabs")!);
        tabs[JSON.parse(sessionStorage.getItem("TabValue")!) - 1] =
          refreshResult?.data?.response[0]?.prescriptionForm;
        sessionStorage.setItem("rxTabs", JSON.stringify(tabs));
        sessionStorage.setItem(
          "rxhubPBMUniqueId",
          refreshResult?.data?.response[0]?.prescriptionForm?.rxhubPBMUniqueId
        );
        setLoading(false);
        if (
          refreshResult?.data?.response[0]?.prescriptionForm
            ?.rtfAlternativeDrugsInfo?.length > 0
        ) {
          handleShowAlternativesPopupClick();
        }
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: refreshResult?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const drugChange = async (values: any, latest: any) => {
    values.dispensibleDrugId = latest;
    values.sig = "";
    values.sigFreqId = "";
    values.sigDeliveryId = "";
    values.sigDoseId = "";
    values.sigDoseUnitsId = "";
    values.sigTimeNight = "";
    values.sigTimeMorning = "";
    values.sigTimeEvening = "";
    values.sigTimeBeforeMeals = "";
    values.sigTimeBeforeBed = "";
    values.sigTimeNoon = "";
    values.sigTimeBedTime = "";
    values.sigTimeAfterMeals = "";
    let bodyData = {
      prescriptionForm: values,
      prescriptionFormList:
        JSON.parse(sessionStorage.getItem("rxTabs") ?? "[]")?.length > 1
          ? JSON.parse(sessionStorage.getItem("rxTabs")!)?.filter(
              (t: any) => t?.drugId != null
            )
          : [],
      patientId: patientId,
      userDetails: {
        userId: loginId,
        doctorId: doctorId,
        onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
        selectedClinicId: sessionStorage.getItem("clinicId") ?? "",
      },
    };

    try {
      setLoading(true);
      const refreshResult = await ChangeDrug(bodyData);
      if (refreshResult?.data?.digitalRxStatusCode === 200) {
        //setData(refreshResult?.data?.response[0]?.prescriptionForm);
        let tabs: any = JSON.parse(sessionStorage.getItem("rxTabs")!);
        tabs[JSON.parse(sessionStorage.getItem("TabValue")!) - 1] =
          refreshResult?.data?.response[0]?.prescriptionForm;
        sessionStorage.setItem("rxTabs", JSON.stringify(tabs));
        props.setTabList(tabs);
        setLoading(false);
        if (
          refreshResult?.data?.response[0]?.prescriptionForm
            ?.rtfAlternativeDrugsInfo?.length > 0
        ) {
          handleShowAlternativesPopupClick();
        }
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: refreshResult?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
        setLoading(false);
        let tabs: any = JSON.parse(sessionStorage.getItem("rxTabs")!);
        props.setTabList(tabs);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const updateEmailReminder = async (values: any) => {
    try {
      const params: any = new URLSearchParams();
      params.append("doctorId", localStorage.getItem("doctorId"));
      params.append("email", values.email);
      const result = await updatePatientEmail(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        setTimeout(() => {
          handleHideEmailUpdatePopupClick();
          dispatch(loadingPrescriberDetails());
          dispatch(loadingPatientDetails());
        }, 1000);
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Sometime!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const setFelidErrors = () => {
    try {
      const errors: any =
        sessionStorage.getItem("rxTabsErrors") != "undefined" ||
        sessionStorage.getItem("rxTabsErrors") !== null
          ? JSON.parse(sessionStorage.getItem("rxTabsErrors")!)
          : null;
      const currentTab = JSON.parse(sessionStorage.getItem("TabValue")!);
      if (errors != null && errors?.length > 0) {
        const error = errors.filter(
          (error: any) => error.rxNumber?.toString() == currentTab
        );
        var rxErrors: any = {};
        error[0]?.errors.map((e: any) => {
          rxErrors[e.field] = e.errorMessage;
        });
        setFormErrors(rxErrors ?? null);
      }
    } catch (err) {}
  };
  useEffect(() => {
    setFelidErrors();
  }, [
    props.newPrescription,
    props.saveAndContinue,
    props.submitAllForms,
    props.resetRxForm,
  ]);
  useEffect(() => {
    setData(panel);
  }, [props.resetRxForm]);

  const alternativeColumns: GridColDef[] = [
    {
      field: "drugDescription",
      headerName: "Drug Description",
      width: 250,
      cellClassName: "w30",
      headerClassName: "w30",
      renderCell: ({ row }) => (
        <TextClick
          onClick={() => {
            getPopulateData(row);
          }}
          Text={
            row?.therapAltdrug
              ? `* ${row?.drugDescription}`
              : `** ${row?.drugDescription}`
          }
        />
      ),
    },
    {
      field: "drugtype",
      headerName: "Type",
      width: 70,
      cellClassName: "w10",
      headerClassName: "w10",
      renderCell: ({ row }) => (
        <>
          <Typography component="div" variant="body2">
            {row?.generic === "Y" ? "G" : "B"}
          </Typography>
        </>
      ),
    },
    {
      field: "rxOtc",
      headerName: "Rx/OTC",
      width: 70,
      cellClassName: "w10",
      headerClassName: "w10",
      renderCell: ({ row }) => (
        <>
          <Typography component="div" variant="body2">
            {row?.otc === "N" ? "Rx" : "OTC"}
          </Typography>
        </>
      ),
    },
    {
      field: "formularyStatusText",
      headerName: "Fmlry. Status",
      width: 250,
      cellClassName: "w30",
      headerClassName: "w30",
    },
    {
      field: "copayTier",
      headerName: "Copay",
      width: 130,
      cellClassName: "w20",
      headerClassName: "w20",
    },
  ];

  const [drugSearchPopup, setDrugSearchPopup] = useState(false);
  const [note, setNote] = useState("NotetoPharmacist");
  const handleNoteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNote((event.target as HTMLInputElement).value);
  };

  const handleShowDrugSearchPopupClick = () => {
    setDrugSearchPopup(true);
  };
  const handleHideDrugSearchPopupClick = () => {
    setDrugSearchPopup(false);
  };

  const [free, SetFree] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [drugDescShow, setDrugDescShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleShowPopupClick = () => {
    setShowPopup(true);
  };
  const handleHidePopupClick = () => {
    setShowPopup(false);
  };

  const [showPopupP, setShowPopupP] = useState(false);
  const handleShowPopupClickP = () => {
    setShowPopupP(true);
  };
  const handleHidePopupClickP = () => {
    setShowPopupP(false);
  };
  const [showFavoritePharmaciesPopup, setShowFavoritePharmaciesPopup] =
    useState(false);
  const handleShowFavoritePharmaciesPopupClick = () => {
    setShowFavoritePharmaciesPopup(true);
  };
  const handleHideFavoritePharmaciesPopupClick = () => {
    setShowFavoritePharmaciesPopup(false);
  };
  const [patientBenefitsPopup, setPatientBenefitsPopup] = useState(false);
  const handleShowPatientBenefitsPopupClick = () => {
    setPatientBenefitsPopup(true);
  };
  const handleHidePatientBenefitsPopupClick = () => {
    setPatientBenefitsPopup(false);
  };

  const [showAlternatives, setAlternativesPopup] = useState(false);
  const handleShowAlternativesPopupClick = () => {
    setAlternativesPopup(true);
  };
  const handleHideAlternativesPopupClick = () => {
    setAlternativesPopup(false);
  };

  const [showPayerPBMSpecifiedAltPopup, setPayerPBMSpecifiedAltPopup] =
    useState(false);
  const handleShowPayerPBMSpecifiedAltPopupClick = () => {
    setPayerPBMSpecifiedAltPopup(true);
  };
  const handleHidePayerPBMSpecifiedAltPopupClick = () => {
    setPayerPBMSpecifiedAltPopup(false);
  };

  const [showTherapeuticalAltPopup, setTherapeuticalAltPopup] = useState(false);
  const handleShowTherapeuticalAltPopupClick = () => {
    setTherapeuticalAltPopup(true);
  };
  const handleHideTherapeuticalAltPopupClick = () => {
    setTherapeuticalAltPopup(false);
  };

  const [showStepMedicationsPopup, setStepMedicationsPopup] = useState(false);
  const handleShowStepMedicationsPopupClick = () => {
    setStepMedicationsPopup(true);
  };
  const handleHideStepMedicationsPopupClick = () => {
    setStepMedicationsPopup(false);
  };

  const [drugPopulateData, setDrugPopulateData] = useState<any>([]);
  const [populateId, setPharmacyPopulateId] = useState<any>([]);
  const [rtpbPharmacyPopData, setRtpbPharmacyPopData] = useState<any>([]);

  useEffect(() => {
    if (drugNameDebounce) {
      dispatch(loadingDrugSearchAjax({ drugName: drugNameDebounce }));
    }
  }, [drugNameDebounce]);

  useEffect(() => {
    if (drugPopulateData[0]) {
      if (drugPopulateData[0]?.prescriptionErrors?.length > 0) {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: drugPopulateData[0]?.prescriptionErrors?.map(
              (each: any) => {
                return (
                  <Box>
                    <Typography
                      component={"div"}
                      fontWeight={600}
                      variant={"body2"}
                    >
                      <strong> Rx-{each?.rxNumber}</strong>
                    </Typography>
                    {each?.errors?.map((ech: any) => {
                      return (
                        <Typography
                          component={"div"}
                          fontWeight={600}
                          variant={"body2"}
                          paddingLeft={2}
                        >
                          {" - "} {ech?.errorMessage}
                        </Typography>
                      );
                    })}
                  </Box>
                );
              }
            ),
            variant: "error",
            open: true,
          };
        });
      }

      setData(drugPopulateData[0]?.prescriptionForm ?? initialStateRxPad);
      if (
        drugPopulateData[0]?.prescriptionForm?.rtfAlternativeDrugsInfo?.length >
        0
      ) {
        handleShowAlternativesPopupClick();
      }
      const currentTabs =
        sessionStorage.getItem("rxTabs") != "undefined" ||
        sessionStorage.getItem("rxTabs") !== null
          ? JSON.parse(sessionStorage.getItem("rxTabs")!)
          : null;
      const updatedForm: any = currentTabs?.map((form: any) => {
        if (form.rxNumber === drugPopulateData[0]?.prescriptionForm?.rxNumber) {
          return (form = drugPopulateData[0]?.prescriptionForm);
        } else {
          return form;
        }
      });
      sessionStorage.setItem("rxTabs", JSON.stringify(updatedForm));
      props.setTabList(updatedForm);
      dispatch(disableClinic());
    }
  }, [drugPopulateData]);

  useEffect(() => {
    if (rtpbPharmacyPopData[0]) {
      setData(rtpbPharmacyPopData[0]?.prescriptionForm ?? initialStateRxPad);
      const currentTabs =
        sessionStorage.getItem("rxTabs") != "undefined" ||
        sessionStorage.getItem("rxTabs") !== null
          ? JSON.parse(sessionStorage.getItem("rxTabs")!)
          : null;
      const updatedForm = currentTabs?.map((form: any) => {
        if (
          form.rxNumber === rtpbPharmacyPopData[0]?.prescriptionForm?.rxNumber
        ) {
          return (form = rtpbPharmacyPopData[0]?.prescriptionForm);
        } else {
          return form;
        }
      });
      sessionStorage.setItem("rxTabs", JSON.stringify(updatedForm));
      props.setTabList(updatedForm);
    }
  }, [rtpbPharmacyPopData]);

  useEffect(() => {
    if (populateId[0]) {
      setData(populateId[0]);
      const currentTabs =
        sessionStorage.getItem("rxTabs") != "undefined" ||
        sessionStorage.getItem("rxTabs") !== null
          ? JSON.parse(sessionStorage.getItem("rxTabs")!)
          : null;
      const updatedForm = currentTabs?.map((form: any) => {
        if (form.rxNumber === populateId[0]?.rxNumber) {
          return (form = populateId[0]);
        } else {
          return form;
        }
      });
      sessionStorage.setItem("rxTabs", JSON.stringify(updatedForm));
      props.setTabList(updatedForm);
    }
  }, [populateId]);

  let lastLogin = localStorage.getItem("LastLogin");
  useEffect(() => {
    return () => {
      localStorage.removeItem("LastLogin");
    };
  }, []);

  return (
    <>
      {loading || pharmacyHisDropDown?.isLoading ? (
        <Box
          style={{
            width: "100%",
            height: 200,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {pharmacyHisDropDown?.isLoading ? (
            <Typography
              variant="body1"
              color={"primary"}
              component="div"
              fontWeight={500}
            >
              Please wait while we fetch the pharmacy!
            </Typography>
          ) : (
            <Typography
              variant="body1"
              color={"primary"}
              component="div"
              fontWeight={500}
            >
              Please wait while populating the drug information!
            </Typography>
          )}

          <CircularProgress color="primary" />
        </Box>
      ) : (
        <Formik
          initialValues={data}
          initialErrors={{ ...formErrors }}
          onSubmit={(values) => {
            setData(values);
            if (
              (values.epcsQueued || values.postDatedPrescription) &&
              [null, ""].includes(
                PrescriberDetailsState?.AllPrescriberDetails?.email
              )
            ) {
              handleShowEmailUpdatePopupClick();

              const forms: [] =
                sessionStorage.getItem("rxTabs") !== "undefined" ||
                sessionStorage.getItem("rxTabs") !== null
                  ? JSON.parse(sessionStorage.getItem("rxTabs")!)
                  : [];

              const updatedForm = forms.map((form: any) => {
                if (form.rxNumber == values.rxNumber) {
                  return (form = values);
                } else {
                  return form;
                }
              });
              sessionStorage.setItem("rxTabs", JSON.stringify(updatedForm));
              props.setTabList(updatedForm);
              if (values.postDatedPrescription && !values.epcsQueued) {
                setStateData((prevState: any) => {
                  return {
                    ...prevState,
                    message:
                      "Email Address is needed to use Post Dated Prescription Functionality",
                    variant: "error",
                    open: true,
                  };
                });
              } else if (values.epcsQueued && !values.postDatedPrescription) {
                setStateData((prevState: any) => {
                  return {
                    ...prevState,
                    message:
                      "Email Address is needed to use EPCS queue Functionality",
                    variant: "error",
                    open: true,
                  };
                });
              } else if (values.epcsQueued && values.postDatedPrescription) {
                setStateData((prevState: any) => {
                  return {
                    ...prevState,
                    message:
                      "Email Address is needed to use EPCS Queue & Post Dated prescriptions Functionality",
                    variant: "error",
                    open: true,
                  };
                });
              }
            } else {
              props.submitAllForms(values);
            }
          }}
          enableReinitialize
        >
          {(formProps) => {
            return (
              <Form onSubmit={formProps.handleSubmit}>
                <Grid
                  container
                  xs={12}
                  alignItems="stretch"
                  justifyContent="stretch"
                  spacing={0}
                >
                  {lastLogin && (
                    <Grid item xs={12} md={12}>
                      <Typography
                        color="primary"
                        variant="body2"
                        component="div"
                        marginBottom={2}
                      >
                        {localStorage.getItem("authenticationType") ===
                        "Integrated"
                          ? lastLogin
                          : ""}
                      </Typography>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <LgCardStyle className="rxpad1">
                      <Grid
                        container
                        item
                        xs={12}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        columnSpacing={2}
                      >
                        <Grid item xs={12} md={6}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              color={blackColor}
                              variant="body2"
                              fontWeight={400}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="mdmw"
                            >
                              Rx Benefit Source
                            </Typography>
                            <DRxSelectStyle>
                              <DRxSelect2
                                name="rxhubPBMUniqueId"
                                options={
                                  data?.rxhubPBMUniqueIdOptions?.map(
                                    (each: any) => ({
                                      label: each?.displayMemberUniqueId,
                                      value: each?.memberUniqueId,
                                    })
                                  ) ?? [{ value: "", label: "" }]
                                }
                                value={formProps.values.rxhubPBMUniqueId}
                                onChange={async (e: any, opt: any) => {
                                  formProps.setFieldValue(
                                    "rxhubPBMUniqueId",
                                    e.target.value
                                  );
                                  benefitRefresh(
                                    formProps.values,
                                    e.target.value
                                  );
                                }}
                                id="rxbenefitsource"
                              />
                            </DRxSelectStyle>
                          </RxPadBox>
                        </Grid>
                        {formProps.values.rxhubPBMUniqueId ? (
                          <>
                            <Grid item xs={12} md={6}>
                              <RxPadBox className="mt7">
                                <Typography
                                  component="label"
                                  color={blackColor}
                                  variant="body2"
                                  fontWeight={400}
                                  style={{
                                    whiteSpace: "nowrap",
                                  }}
                                  className="mdmw"
                                >
                                  Benefits
                                </Typography>
                                <Typography
                                  component="div"
                                  color="primary"
                                  variant="body2"
                                >
                                  {data?.pharmacyBenifits}
                                </Typography>
                              </RxPadBox>
                            </Grid>
                          </>
                        ) : (
                          ""
                        )}
                      </Grid>
                    </LgCardStyle>
                  </Grid>{" "}
                  <Grid item xs={12} lg={6}>
                    <LgCardStyle className="rxpad2">
                      <Grid
                        container
                        item
                        xs={12}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        columnSpacing={2}
                        rowSpacing={1}
                      >
                        <Grid item xs={12} md={12}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              color={blackColor}
                              variant="body2"
                              fontWeight={400}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="mdmw"
                            >
                              Drug Name
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body2"
                              >
                                *
                              </Typography>
                            </Typography>
                            <DRxSelectStyle className="icon">
                              <YSSelectSearch
                                id="drugName"
                                isOptionEqualToValue={(
                                  option: any,
                                  value: any
                                ) => option.label === value}
                                options={
                                  DrugSearchAjaxState?.Items?.map(
                                    (item: any, index: any) => ({
                                      value: item?.drugId,
                                      label: item?.drugName,
                                    })
                                  ) ?? [{ value: "", label: "" }]
                                }
                                name="drugName"
                                value={formProps.values.drugName}
                                onInputChange={(option: any, e: any) => {
                                  formProps.setFieldValue("drugName", e);
                                  setDrugNameState(e);
                                }}
                                onChange={(event: any, value: any) => {
                                  formProps.setFieldValue(
                                    "drugId",
                                    value?.value
                                  );
                                  if (formProps.values.drugId !== "") {
                                    handleShowDrugSearchPopupClick();
                                  }
                                }}
                                errorMessage={formProps.errors?.drugName}
                              />
                              <IconButton
                                color="secondary"
                                className="drugNameSearch"
                                onClick={handleShowDrugSearchPopupClick}
                              >
                                <img
                                  src={SearchIcon}
                                  alt="SearchIcon"
                                  loading="lazy"
                                />
                              </IconButton>

                              <DialogPopup
                                windowsize={"md"}
                                title={"Please select a medication"}
                                show={drugSearchPopup}
                                handleShowPopupClick={
                                  handleShowDrugSearchPopupClick
                                }
                                handleHidePopupClick={
                                  handleHideDrugSearchPopupClick
                                }
                              >
                                <DrugDataList
                                  setDrugDescShow={setDrugDescShow}
                                  setDrugPopulateData={setDrugPopulateData}
                                  SetFree={SetFree}
                                  free={free}
                                  setStateData={setStateData}
                                  passingBodyData={formProps?.values}
                                  drugSearchPopup
                                  handleShowPopupClick={
                                    handleShowDrugSearchPopupClick
                                  }
                                  handleHidePopupClick={
                                    handleHideDrugSearchPopupClick
                                  }
                                />
                              </DialogPopup>
                            </DRxSelectStyle>
                          </RxPadBox>
                        </Grid>
                        <Grid item xs={12} sm={8} md={6}>
                          <RxPadBox className="mt5">
                            <Typography
                              component="label"
                              color={blackColor}
                              variant="body2"
                              htmlFor="dtype"
                              fontWeight={400}
                              style={{
                                whiteSpace: "nowrap",
                              }}
                              className="mdmw"
                            >
                              Drug type
                            </Typography>
                            <DRxSelectStyle>
                              <DRxSelect
                                id="dtype"
                                data={
                                  AllDropdwonsState?.drugsTypesOptions ?? [
                                    { label: "", value: "" },
                                  ]
                                }
                                name="drugType"
                                className=""
                                disabled={
                                  formProps.values.drugTypeOptionsDisableFlag
                                }
                              />
                            </DRxSelectStyle>
                            {data?.rxOtcCode && (
                              <Typography
                                component="div"
                                color="error"
                                variant="body2"
                                fontWeight={500}
                                marginLeft={1}
                                marginTop={1}
                              >
                                {data?.rxOtcCode === "Prescription Required"
                                  ? "Rx"
                                  : "OTC"}
                              </Typography>
                            )}
                          </RxPadBox>
                        </Grid>{" "}
                        <Grid item xs={12} sm={4} md={6}>
                          <DRxCheckboxStyle className="fr addToFavoriteDrugs">
                            <YSCheckBox
                              name="addToFavoriteDrugs"
                              label={"Add to favorite drug"}
                            />
                          </DRxCheckboxStyle>
                        </Grid>
                        {(drugDescShow ||
                          data?.sigDrugNameRouteStrengthOptions) && (
                          <Grid item xs={12} md={12}>
                            <RxPadBox>
                              <Typography
                                component="label"
                                color={blackColor}
                                variant="body2"
                                fontWeight={400}
                                style={{
                                  marginTop: 6,
                                  whiteSpace: "nowrap",
                                }}
                                className="mdmw"
                              >
                                Drug
                                <Typography
                                  component="span"
                                  color={warnColor}
                                  variant="body2"
                                >
                                  *
                                </Typography>
                              </Typography>
                              <DRxSelectStyle>
                                <DRxSelect2
                                  name="dispensibleDrugId"
                                  id="rxrequireddrug"
                                  options={
                                    data?.sigDrugNameRouteStrengthOptions ?? [
                                      {
                                        value: "",
                                        label: "",
                                      },
                                    ]
                                  }
                                  value={formProps.values.dispensibleDrugId}
                                  onChange={(e) => {
                                    drugChange(
                                      formProps.values,
                                      e.target.value
                                    );
                                  }}
                                />
                              </DRxSelectStyle>
                            </RxPadBox>
                          </Grid>
                        )}
                        {data?.deaClassCode ? (
                          <>
                            <Grid item xs={12} md={6}>
                              <RxPadBox>
                                {/* <Typography
                                  component="span"
                                  color={blackColor}
                                  variant="body2"
                                  fontWeight={400}
                                  style={{
                                    marginTop: 13,
                                    whiteSpace: "nowrap", 
                                  }}
                                  className="mdmw"
                                >
                                  Scheduled Drug
                                </Typography> */}
                                <Typography
                                  component="div"
                                  color="primary"
                                  variant="body2"
                                  fontWeight={400}
                                  className="schdrug"
                                  style={{
                                    marginTop: 7,
                                  }}
                                >
                                  {data?.deaClassCode}
                                </Typography>{" "}
                              </RxPadBox>
                            </Grid>
                          </>
                        ) : null}
                        {/* {data?.rxOtcCode ? (
                          <Grid item xs={12} md={6}>
                            <RxPadBox>
                              <Typography
                                component="div"
                                color="primary"
                                variant="body2"
                                fontWeight={400}
                                style={{
                                  marginTop: 10,
                                }}
                              >
                                {data?.rxOtcCode}
                              </Typography>{" "}
                            </RxPadBox>
                          </Grid>
                        ) : null} */}
                      </Grid>
                    </LgCardStyle>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <LgCardStyle className="rft rxpad3">
                      <Grid
                        container
                        item
                        xs={12}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        columnSpacing={2}
                        rowSpacing={1}
                      >
                        {(free || formProps.values.sig !== "") &&
                        (!formProps.values.sigFreqId ||
                          !formProps.values.sigDeliveryId ||
                          !formProps.values.sigDoseId ||
                          !formProps.values.sigDoseUnitsId) ? (
                          <Grid item xs={12} md={12}>
                            <RxPadBox>
                              <Typography
                                component="label"
                                color={blackColor}
                                variant="body2"
                                fontWeight={400}
                                style={{
                                  marginTop: 7,
                                  whiteSpace: "nowrap",
                                }}
                                className="mdmw"
                              >
                                SIG
                                <Typography
                                  component="span"
                                  color={warnColor}
                                  variant="body2"
                                >
                                  *
                                </Typography>
                              </Typography>

                              <DRxTextareaStyle className="sig">
                                <DRxTextarea
                                  type="textarea"
                                  name="sig"
                                  id={"sig"}
                                />
                                {formProps.values.sig && (
                                  <Typography
                                    component="label"
                                    color={"primary"}
                                    variant="body2"
                                  >
                                    Please do not use latin abbreviations like
                                    BID, QID etc., when writing free text SIG.
                                  </Typography>
                                )}
                              </DRxTextareaStyle>
                            </RxPadBox>
                          </Grid>
                        ) : (
                          <>
                            <Grid item xs={12} sm={6}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  color={blackColor}
                                  variant="body2"
                                  fontWeight={400}
                                  className="mdmw"
                                >
                                  Route of Administration
                                  <Typography
                                    component="span"
                                    color={warnColor}
                                    variant="body2"
                                  >
                                    *
                                  </Typography>
                                </Typography>
                                <DRxSelectStyle>
                                  <DRxSelect2
                                    id="delivery"
                                    name="sigDeliveryId"
                                    label="Delivery"
                                    options={
                                      AllDropdwonsState?.sigDeliveryOptions?.map(
                                        (each: any) => ({
                                          label: each?.name,
                                          value: each?.sfid,
                                        })
                                      ) ?? [{ label: "", value: "" }]
                                    }
                                    onChange={(options: any, e: any) => {
                                      formProps.setFieldValue(
                                        "sigDeliveryId",
                                        e.props.value
                                      );
                                    }}
                                    value={formProps.values.sigDeliveryId}
                                    onBlur={formProps.handleBlur}
                                    errorMessage={
                                      formProps.errors?.sigDeliveryId
                                    }
                                  />
                                </DRxSelectStyle>
                              </RxPadBox>
                            </Grid>{" "}
                            <Grid item xs={12} sm={6}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  variant="body2"
                                  color={blackColor}
                                  fontWeight={400}
                                  style={{
                                    marginTop: 7,
                                    whiteSpace: "nowrap",
                                  }}
                                  className="xsmw"
                                >
                                  Dose
                                  <Typography
                                    component="span"
                                    color={warnColor}
                                    variant="body2"
                                  >
                                    *
                                  </Typography>
                                </Typography>
                                <DRxSelectStyle>
                                  <DRxSelect2
                                    name="sigDoseId"
                                    id="dose"
                                    options={
                                      AllDropdwonsState?.sigDoseOptions?.map(
                                        (each: any) => ({
                                          label: each?.name,
                                          value: each?.sfid,
                                        })
                                      ) ?? [{ label: "", value: "" }]
                                    }
                                    onChange={(option: any, e: any) => {
                                      formProps.setFieldValue(
                                        "sigDoseId",
                                        e.props.value
                                      );
                                    }}
                                    value={formProps.values.sigDoseId}
                                    errorMessage={formProps.errors?.sigDoseId}
                                  />
                                </DRxSelectStyle>
                              </RxPadBox>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  variant="body2"
                                  fontWeight={400}
                                  color={blackColor}
                                  style={{
                                    marginTop: 7,
                                    whiteSpace: "nowrap",
                                  }}
                                  className="mdmw"
                                >
                                  Units
                                  <Typography
                                    component="span"
                                    color={warnColor}
                                    variant="body2"
                                  >
                                    *
                                  </Typography>
                                </Typography>
                                <DRxSelectStyle>
                                  <DRxSelect2
                                    name="sigDoseUnitsId"
                                    id="units"
                                    options={
                                      AllDropdwonsState?.sigDoseUnitsOptions?.map(
                                        (each: any) => ({
                                          label: each?.name,
                                          value: each?.sfid,
                                        })
                                      ) ?? [{ label: "", value: "" }]
                                    }
                                    onChange={(options: any, e: any) => {
                                      formProps.setFieldValue(
                                        "sigDoseUnitsId",
                                        e.props.value
                                      );
                                    }}
                                    value={formProps.values.sigDoseUnitsId}
                                    errorMessage={
                                      formProps.errors?.sigDoseUnitsId
                                    }
                                  />
                                </DRxSelectStyle>
                              </RxPadBox>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  variant="body2"
                                  color={blackColor}
                                  fontWeight={400}
                                  style={{
                                    marginTop: 7,
                                    whiteSpace: "nowrap",
                                  }}
                                  className="xsmw"
                                >
                                  Freq
                                  <Typography
                                    component="span"
                                    color={warnColor}
                                    variant="body2"
                                  >
                                    *
                                  </Typography>
                                </Typography>
                                <DRxSelectStyle>
                                  <DRxSelect2
                                    name="sigFreqId"
                                    id="freq"
                                    options={
                                      AllDropdwonsState?.sigFreqOptions?.map(
                                        (each: any) => ({
                                          label: each?.name,
                                          value: each?.sfid,
                                        })
                                      ) ?? [{ label: "", value: "" }]
                                    }
                                    onChange={(option: any, e: any) => {
                                      formProps.setFieldValue(
                                        "sigFreqId",
                                        e.props.value
                                      );
                                    }}
                                    value={formProps.values.sigFreqId}
                                    errorMessage={formProps.errors?.sigFreqId}
                                  />
                                </DRxSelectStyle>
                              </RxPadBox>
                            </Grid>
                            <Grid item xs={12} md={12}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  color={blackColor}
                                  variant="body2"
                                  fontWeight={400}
                                  style={{
                                    marginTop: 7,
                                    whiteSpace: "nowrap",
                                  }}
                                  className="mdmw"
                                >
                                  SIG
                                  <Typography
                                    component="span"
                                    color={warnColor}
                                    variant="body2"
                                  >
                                    *
                                  </Typography>
                                </Typography>
                                <DRxInputStyle className="icon">
                                  <DRxInput
                                    id="sig"
                                    name="sig"
                                    type="text"
                                    className="input"
                                    disabled={false}
                                    inputProps={{ readOnly: true }}
                                    errorMessage={formProps.errors?.sig}
                                    value={getLabels(formProps)}
                                  />

                                  <DialogPopup
                                    windowsize={"sm"}
                                    icon={TimeIcon}
                                    title={"Time"}
                                    show={showPopup}
                                    handleShowPopupClick={handleShowPopupClick}
                                    handleHidePopupClick={handleHidePopupClick}
                                  >
                                    <TimeList
                                      showPopup
                                      setShowPopup
                                      handleShowPopupClick={
                                        handleShowPopupClick
                                      }
                                      handleHidePopupClick={
                                        handleHidePopupClick
                                      }
                                      formProps={formProps}
                                    />
                                  </DialogPopup>
                                </DRxInputStyle>
                              </RxPadBox>
                            </Grid>
                          </>
                        )}
                        <Grid item xs={12} md={12}>
                          <RxPadBox>
                            {" "}
                            <Typography
                              component="label"
                              variant="body2"
                              className="mdmw"
                            ></Typography>
                            <DRxCheckboxStyle
                              style={{ left: -5, position: "relative" }}
                            >
                              <Typography
                                className="usefreetext"
                                variant="body2"
                                component={"label"}
                              >
                                <Checkbox
                                  name={"freeText1"}
                                  checked={
                                    (free || formProps.values.sig !== "") &&
                                    (!formProps.values.sigFreqId ||
                                      !formProps.values.sigDeliveryId ||
                                      !formProps.values.sigDoseId ||
                                      !formProps.values.sigDoseUnitsId)
                                  }
                                  onChange={(e: any) => {
                                    SetFree(!free);

                                    if (e.target.checked) {
                                      formProps.setFieldValue("sig", "");
                                      formProps.setFieldValue(
                                        "sigDeliveryId",
                                        ""
                                      );

                                      formProps.setFieldValue("sigDoseId", "");
                                      formProps.setFieldValue(
                                        "sigDoseUnitsId",
                                        ""
                                      );
                                      formProps.setFieldValue("sigFreqId", "");
                                      formProps.setFieldValue(
                                        "sigTimeMorning",
                                        ""
                                      );
                                      formProps.setFieldValue(
                                        "sigTimeNoon",
                                        ""
                                      );
                                      formProps.setFieldValue(
                                        "sigTimeEvening",
                                        ""
                                      );
                                      formProps.setFieldValue(
                                        "sigTimeNight",
                                        ""
                                      );
                                      formProps.setFieldValue(
                                        "sigTimeBedTime",
                                        ""
                                      );
                                      formProps.setFieldValue(
                                        "sigTimeBeforeMeals",
                                        ""
                                      );
                                      formProps.setFieldValue(
                                        "sigTimeAfterMeals",
                                        ""
                                      );
                                      formProps.setFieldValue(
                                        "sigTimeBeforeBed",
                                        ""
                                      );
                                    } else {
                                      formProps.setFieldValue("sig", "");
                                    }
                                  }}
                                />
                                Use free text
                              </Typography>
                            </DRxCheckboxStyle>
                          </RxPadBox>
                        </Grid>{" "}
                      </Grid>
                    </LgCardStyle>
                  </Grid>{" "}
                  <Grid item xs={12} lg={6}>
                    <LgCardStyle className="rxpad4">
                      <Grid
                        container
                        item
                        xs={12}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        columnSpacing={2}
                        rowSpacing={1}
                      >
                        <Grid item xs={12} sm={8}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              color={blackColor}
                              variant="body2"
                              fontWeight={400}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="mdmw"
                            >
                              Qualifier
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body2"
                              >
                                *
                              </Typography>
                            </Typography>
                            <DRxSelectStyle className="qualifier">
                              <DRxSelect2
                                name="packSizeUnitCode"
                                id="packSizeUnitCode"
                                options={
                                  data?.qtyQualifiersOptions ?? [
                                    { label: "", value: "" },
                                  ]
                                }
                                onChange={(e: any, opt: any) => {
                                  formProps.setFieldValue(
                                    "packSizeUnitCode",
                                    opt.props.value
                                  );
                                  formProps.setFieldValue(
                                    "qtyQualifier",
                                    opt.props.children
                                  );
                                }}
                                value={formProps.values.packSizeUnitCode}
                                errorMessage={formProps.errors?.qtyQualifier}
                              />
                            </DRxSelectStyle>
                          </RxPadBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              variant="body2"
                              color={blackColor}
                              fontWeight={400}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="xsmw"
                            >
                              Quantity
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body2"
                              >
                                *
                              </Typography>
                            </Typography>
                            <DRxInputStyle className="w-auto quantity">
                              <DRxInput
                                id="quantity"
                                name="quantity"
                                type="text"
                                className="input "
                                disabled={false}
                              />
                            </DRxInputStyle>
                          </RxPadBox>
                        </Grid>{" "}
                        <Grid item xs={12} sm={8}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={400}
                              color={blackColor}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="mdmw"
                            >
                              Substitutions
                            </Typography>
                            <DRxSelectStyle className="substitutions">
                              <DRxSelect
                                name="substitutionCode"
                                id="substitute"
                                data={
                                  AllDropdwonsState?.substitutionCodeOptions ?? [
                                    { label: "", value: "" },
                                  ]
                                }
                              />
                            </DRxSelectStyle>
                          </RxPadBox>
                        </Grid>{" "}
                        <Grid item xs={12} sm={4}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              color={blackColor}
                              variant="body2"
                              fontWeight={400}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="xsmw"
                            >
                              Refill
                            </Typography>
                            <DRxInputStyle className="w-auto refill">
                              <DRxInput
                                id="refill"
                                name="refills"
                                type="text"
                                className="input "
                                disabled={
                                  formProps?.values?.refillsDisableFlag
                                    ? true
                                    : false
                                }
                              />
                            </DRxInputStyle>
                          </RxPadBox>
                        </Grid>
                      </Grid>
                    </LgCardStyle>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <LgCardStyle className="rft rxpad5">
                      <Grid
                        container
                        item
                        xs={12}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        columnSpacing={2}
                        rowSpacing={1}
                      >
                        <Grid item xs={12} md={6}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              variant="body2"
                              color={blackColor}
                              fontWeight={400}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="mdmw"
                            >
                              Daily Max Dose
                            </Typography>
                            <DRxInputStyle className="w-auto dailymaxdose">
                              <DRxInput
                                id="dailymaxdose"
                                name="dailyMaxDose"
                                type="text"
                                className="input"
                                disabled={false}
                                label={"Daily Max Dose"}
                              />
                            </DRxInputStyle>
                          </RxPadBox>
                        </Grid>{" "}
                        <Grid item xs={12} md={6}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={400}
                              color={blackColor}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="xsmw"
                            >
                              WC/XFR
                            </Typography>
                            <DRxSelectStyle>
                              <DRxSelect
                                name="wcxfrIndicator"
                                id="wcxfr"
                                data={
                                  AllDropdwonsState?.wcxfroptions ?? [
                                    { label: "", value: "" },
                                  ]
                                }
                              />{" "}
                            </DRxSelectStyle>
                          </RxPadBox>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              variant="body2"
                              color={blackColor}
                              fontWeight={400}
                              style={{
                                whiteSpace: "nowrap",
                                position: "relative",
                              }}
                              className="mdmw"
                            >
                              Days Supply{" "}
                              <HtmlTooltip
                                placement="right"
                                arrow
                                title={
                                  <>
                                    <Typography
                                      variant="body2"
                                      component={"div"}
                                      style={{
                                        position: "relative",
                                      }}
                                    >
                                      <img
                                        src={PatientBenefitIcon}
                                        alt="PatientBenefitIcon"
                                        style={{
                                          verticalAlign: "middle",
                                          width: 30,
                                        }}
                                      />
                                      Enter days supply to view patient benefit
                                    </Typography>
                                  </>
                                }
                              >
                                <IconButton className="tooltip ds">
                                  <img
                                    src={InfoIcon}
                                    alt="InfoIcon"
                                    loading="lazy"
                                  />
                                </IconButton>
                              </HtmlTooltip>
                            </Typography>
                            <DRxInputStyle className="w-auto">
                              <DRxInput
                                id="daysSupply"
                                name="daysSupply"
                                type="text"
                                className="input"
                                disabled={
                                  UserServiceState?.disableDaysSupplyField &&
                                  formProps.values.rxhubPBMUniqueId ===
                                    "SELECT_BENEFIT_SOURCE"
                                    ? true
                                    : false
                                }
                                value={
                                  UserServiceState?.disableDaysSupplyField &&
                                  formProps.values.rxhubPBMUniqueId ===
                                    "SELECT_BENEFIT_SOURCE"
                                    ? "N/A"
                                    : formProps.values.daysSupply
                                }
                              />
                            </DRxInputStyle>
                          </RxPadBox>{" "}
                        </Grid>{" "}
                        <Grid item xs={12} md={6}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              variant="body2"
                              color={blackColor}
                              fontWeight={400}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="xsmw"
                            >
                              Type
                            </Typography>
                            <DRxSelectStyle>
                              <DRxSelect
                                name="type"
                                id="type"
                                data={
                                  AllDropdwonsState?.type ?? [
                                    { label: "", value: "" },
                                  ]
                                }
                              />
                            </DRxSelectStyle>
                          </RxPadBox>
                        </Grid>
                      </Grid>
                    </LgCardStyle>
                  </Grid>{" "}
                  {(formProps.values.diagnosisIcdOptions?.length > 0 ||
                    formProps.values.narcoticDrugFlag) && (
                    <Grid item xs={12} lg={12}>
                      <LgCardStyle className="rxpad6">
                        <Grid
                          container
                          item
                          xs={12}
                          alignItems="flex-start"
                          justifyContent="flex-start"
                          columnSpacing={2}
                          rowSpacing={1}
                        >
                          {data?.diagnosisIcdOptions?.length > 0 && (
                            <Grid item xs={12} md={6}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  variant="body2"
                                  color={blackColor}
                                  fontWeight={400}
                                  style={{
                                    marginTop: 7,
                                    whiteSpace: "nowrap",
                                  }}
                                  className="mdmw"
                                >
                                  Diagnosis
                                </Typography>
                                <DRxSelectStyle>
                                  <DRxSelect
                                    name="diagnosisIcd"
                                    id="diagnosis"
                                    data={
                                      data?.diagnosisIcdOptions ?? [
                                        { label: "", value: "" },
                                      ]
                                    }
                                  />
                                </DRxSelectStyle>
                              </RxPadBox>
                            </Grid>
                          )}
                          {data?.narcoticDrugFlag && (
                            <Grid item xs={12} lg={6}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  variant="body2"
                                  color={blackColor}
                                  fontWeight={400}
                                  style={{
                                    marginTop: 7,
                                    whiteSpace: "nowrap",
                                  }}
                                  className="smmw"
                                >
                                  NADEAN
                                  <br />
                                  /XDEA
                                </Typography>
                                <DRxInputStyle>
                                  <DRxInput
                                    id="Xdea"
                                    name="xdeaNumber"
                                    label={"Enter NADEAN / XDEA"}
                                  />{" "}
                                  <Typography variant="body2" color="primary">
                                    Please fill the number in prescribed format
                                    only.(2 characters then followed by 7
                                    digits)
                                  </Typography>
                                </DRxInputStyle>
                              </RxPadBox>
                            </Grid>
                          )}
                        </Grid>
                      </LgCardStyle>
                    </Grid>
                  )}
                  {formProps.values.rxhubPBMUniqueId !==
                    "SELECT_BENEFIT_SOURCE" && (
                    <>
                      <Grid item xs={12}>
                        <LgCardStyle className="rxpad7">
                          <Grid
                            container
                            item
                            xs={12}
                            alignItems="flex-start"
                            justifyContent="flex-start"
                            columnSpacing={2}
                            rowSpacing={1}
                          >
                            <Grid item xs={12}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  variant="body2"
                                  color={blackColor}
                                  fontWeight={400}
                                  style={{
                                    marginTop: 8,
                                    whiteSpace: "nowrap",
                                  }}
                                  className="mdmw"
                                >
                                  Formulary Status
                                </Typography>
                                <Box>
                                  <Typography
                                    component="div"
                                    color="primary"
                                    variant="body2"
                                    fontWeight={600}
                                    style={{ marginBottom: 5 }}
                                  >
                                    {data?.formularyStatus ?? "Not Available"}
                                  </Typography>{" "}
                                  {data?.therapeuticalAlternativeDrugs?.length >
                                    0 && (
                                    <YSButton
                                      style={{ marginBottom: 5 }}
                                      size="medium"
                                      className=" "
                                      color="primary"
                                      dataTestId="submitBtn"
                                      variant="contained"
                                      disabled={false}
                                      type="button"
                                      children={"Therapeutical Alternatives"}
                                      onClick={
                                        handleShowTherapeuticalAltPopupClick
                                      }
                                    />
                                  )}
                                  {data?.payerAlternativeDrugs?.length > 0 && (
                                    <YSButton
                                      style={{
                                        marginBottom: 5,
                                        marginLeft: 2,
                                      }}
                                      size="medium"
                                      className=" "
                                      color="primary"
                                      dataTestId="submitBtn"
                                      variant="contained"
                                      disabled={false}
                                      type="button"
                                      children={"Payer/PBM Alternatives"}
                                      onClick={
                                        handleShowPayerPBMSpecifiedAltPopupClick
                                      }
                                    />
                                  )}
                                  {formProps?.values?.stepMedicationsList
                                    ?.length > 0 && (
                                    <YSButton
                                      style={{ marginBottom: 5, marginLeft: 2 }}
                                      size="medium"
                                      className=" "
                                      color="primary"
                                      dataTestId="submitBtn"
                                      variant="contained"
                                      disabled={false}
                                      type="button"
                                      children={"Step Medications"}
                                      onClick={
                                        handleShowStepMedicationsPopupClick
                                      }
                                    />
                                  )}
                                </Box>
                              </RxPadBox>
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  variant="body2"
                                  color={blackColor}
                                  fontWeight={400}
                                  style={{
                                    whiteSpace: "nowrap",
                                  }}
                                  className="mdmw"
                                >
                                  Copay
                                </Typography>
                                <Typography
                                  component="div"
                                  color="primary"
                                  variant="body2"
                                  fontWeight={600}
                                  overflow={"auto"}
                                  maxHeight={200}
                                >
                                  {data?.copay ?? "Not Available"}
                                </Typography>{" "}
                              </RxPadBox>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <RxPadBox>
                                <Typography
                                  component="label"
                                  variant="body2"
                                  color={blackColor}
                                  fontWeight={400}
                                  style={{
                                    whiteSpace: "nowrap",
                                  }}
                                  className="mdmw"
                                >
                                  Coverage
                                </Typography>
                                {data?.paRequiredFlag !== "1" ? (
                                  <Typography
                                    component="div"
                                    color="primary"
                                    variant="body2"
                                    fontWeight={400}
                                    overflow={"auto"}
                                    maxHeight={200}
                                  >
                                    {data?.coverage ?? "Not Available"}
                                  </Typography>
                                ) : (
                                  <>
                                    <Typography
                                      component="div"
                                      variant="body2"
                                      color="#db5e14"
                                      fontWeight={400}
                                      overflow={"auto"}
                                      maxHeight={200}
                                      display={"flex"}
                                      alignItems={"flex-start"}
                                    >
                                      <img
                                        style={{
                                          marginTop: "4px",
                                        }}
                                        src={WarningIcon}
                                        alt="warningIcon"
                                        loading="lazy"
                                      />
                                      <span
                                        style={{
                                          marginLeft: 5,
                                          // wordBreak: "break-wrod",
                                        }}
                                      >
                                        {data?.coverage
                                          ? data?.coverage?.slice(0, 29)
                                          : "Not Available"}
                                        <span
                                          style={{
                                            color: primaryColor,
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {data?.coverage?.slice(29)}
                                        </span>
                                      </span>
                                    </Typography>
                                  </>
                                )}
                              </RxPadBox>{" "}
                            </Grid>
                            {data?.drugResourceLinkOptions?.map((each: any) => {
                              return (
                                <Grid item xs={12} md={6}>
                                  <RxPadBox>
                                    <a
                                      href={each?.label ?? "/"}
                                      target={"_blank"}
                                      rel="noreferrer"
                                    >
                                      {each?.value ?? ""}
                                    </a>
                                  </RxPadBox>{" "}
                                </Grid>
                              );
                            })}
                            {/* <Grid item xs={12} md={6}>
                            <RxPadBox>
                              <a
                                href={
                                  data?.drugResourceLink != null
                                    ? data?.drugResourceLink[0] ?? "/"
                                    : "/"
                                }
                                target={"_blank"}
                              >
                                Resource Link for Prior Authorization
                              </a>
                            </RxPadBox>{" "}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <RxPadBox>
                              <a
                                href={
                                  data?.drugResourceLink != null
                                    ? data?.drugResourceLink[1] ?? "/"
                                    : "/"
                                }
                                target={"_blank"}
                              >
                                Resource Link for Step Therapy
                              </a>
                            </RxPadBox>{" "}
                          </Grid> */}
                          </Grid>
                        </LgCardStyle>
                      </Grid>
                    </>
                  )}
                  {/* Disable this entire */}
                  <Grid item xs={12} lg={6}>
                    <LgCardStyle className="rxpad8">
                      <Grid
                        container
                        item
                        xs={12}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        columnSpacing={2}
                        rowSpacing={1}
                      >
                        <Grid item xs={12} md={12}>
                          <RxPadBox>
                            <Typography
                              component="label"
                              color={blackColor}
                              variant="body2"
                              fontWeight={400}
                              style={{
                                marginTop: 7,
                                whiteSpace: "nowrap",
                              }}
                              className="mdmw"
                            >
                              Pharmacy
                              <Typography
                                component="span"
                                color={warnColor}
                                variant="body2"
                              >
                                *
                              </Typography>
                              {pharmacyHisDropDown?.PharmacyDropDownData &&
                                pharmacyHisDropDown?.PharmacyDropDownData
                                  ?.length > 0 &&
                                pharmacyHisDropDown?.PharmacyDropDownData?.find(
                                  (item: any) =>
                                    item.pharmacyCode ===
                                    formProps.values.phamacyCode
                                )?.patientPreferredPharmacy && (
                                  <Typography
                                    component="div"
                                    variant="caption"
                                    color="primary"
                                    display="flex"
                                    alignItems="center"
                                  >
                                    <img
                                      src={PreferredPharmacyIcon}
                                      alt="preffered"
                                      loading="lazy"
                                      width={18}
                                      height={18}
                                    />
                                    Preferred Choice
                                  </Typography>
                                )}
                            </Typography>{" "}
                            <DRxSelectStyle className="icon">
                              <DRxSelect2
                                ref={pharmacyCodeRef}
                                name="pharmacyCode"
                                id="pharmacyCode"
                                options={
                                  pharmacyHisDropDown?.PharmacyDropDownData?.map(
                                    (item: any) => ({
                                      value: item?.pharmacyCode,
                                      label: item?.nameConcatenatedWithAddress,
                                      optionColor: !item?.ssEnableFlag
                                        ? "yellow"
                                        : "",
                                    })
                                  ) ?? [
                                    {
                                      value: "",
                                      label: "",
                                      optionColor: "",
                                    },
                                  ]
                                }
                                setPharmacyCodeOptionClass={
                                  setPharmacyCodeOptionClass
                                }
                                optionColorClass={pharmacyCodeOptionClass}
                                value={formProps.values.pharmacyCode}
                                onChange={(e: any, opt: any) => {
                                  if (
                                    getEPCSControlSubstance(
                                      formProps.values,
                                      e.target.value
                                    ) === false
                                  ) {
                                    formProps.setFieldValue(
                                      "epcsQueued",
                                      false
                                    );
                                  }
                                  pharmacyCodeRef.current !== null &&
                                    pharmacyCodeRef.current.classList.remove(
                                      "yellow"
                                    );
                                  formProps.setFieldValue(
                                    "pharmacyCode",
                                    e.target.value
                                  );
                                }}
                                disabled={
                                  formProps?.values?.pharmacyEditDisableFlag
                                }
                                errorMessage={formProps.errors?.pharmacyCode}
                              />
                              <IconButton
                                color="secondary"
                                className="drugNameSearch"
                                onClick={handleShowPopupClickP}
                                disabled={
                                  formProps?.values?.pharmacyEditDisableFlag
                                }
                              >
                                <img
                                  src={SearchIcon}
                                  alt="SearchIcon"
                                  loading="lazy"
                                />
                              </IconButton>
                              {getEPCSControlSubstance(formProps.values) ===
                                false &&
                                formProps?.values?.pharmacyCode !== "0" &&
                                formProps?.values?.controlledSubstance ===
                                  true && (
                                  <Typography
                                    component="label"
                                    color={"orange"}
                                    variant="body2"
                                  >
                                    Pharmacy disabled e-Rx for controlled
                                    substances
                                  </Typography>
                                )}
                            </DRxSelectStyle>
                          </RxPadBox>
                        </Grid>{" "}
                        <Grid item xs={12} md={12}>
                          <BenefitsBtnStyle>
                            <YSButton
                              className=" "
                              onClick={handleShowFavoritePharmaciesPopupClick}
                              type="button"
                              variant="contained"
                              color="primary"
                              children={"Pharmacies"}
                              size="small"
                              startIcon={
                                <img
                                  src={HeartIcon}
                                  alt="HeartIcon"
                                  loading="lazy"
                                />
                              }
                              disabled={
                                formProps?.values?.pharmacyEditDisableFlag
                              }
                            />{" "}
                            {UserServiceState?.rtfRtpbEnabled &&
                              formProps?.values?.rxhubPBMUniqueId !==
                                "SELECT_BENEFIT_SOURCE" && (
                                <YSButton
                                  size="small"
                                  className=""
                                  color="primary"
                                  dataTestId="submitBtn"
                                  variant="contained"
                                  disabled={
                                    formProps?.values?.pharmacyEditDisableFlag
                                  }
                                  type="button"
                                  children={"Patient Benefit"}
                                  startIcon={
                                    <img
                                      src={PatientBenefitsCheckIcon}
                                      alt="PatirntBenifitCheckIcon"
                                      loading="lazy"
                                    />
                                  }
                                  onClick={handleShowPatientBenefitsPopupClick}
                                />
                              )}
                          </BenefitsBtnStyle>
                        </Grid>
                        <DialogPopup
                          windowsize={"lg"}
                          title={"Available Patient Benefits"}
                          show={patientBenefitsPopup}
                          handleShowPopupClick={
                            handleShowPatientBenefitsPopupClick
                          }
                          handleHidePopupClick={
                            handleHidePatientBenefitsPopupClick
                          }
                        >
                          <PatientBenefitsCheck
                            setRtpbPharmacyPopData={setRtpbPharmacyPopData}
                            formData={formProps.values}
                            handleHidePopupClick={
                              handleHidePatientBenefitsPopupClick
                            }
                          />
                        </DialogPopup>
                        {/* search pharmacy */}
                        <DialogPopup
                          windowsize={"md"}
                          title={"Search Pharmacies"}
                          show={showPopupP}
                          handleShowPopupClick={handleShowPopupClickP}
                          handleHidePopupClick={handleHidePopupClickP}
                        >
                          <PharmacyDataList
                            formData={formProps.values}
                            setPharmacyPopulateId={setPharmacyPopulateId}
                            pharmacyInfoState={false}
                            handleHidePopupClick={handleHidePopupClickP}
                          />
                        </DialogPopup>
                        {/* fav pharmacies */}
                        <DialogPopup
                          windowsize={"md"}
                          title={"Favorite Pharmacies"}
                          show={showFavoritePharmaciesPopup}
                          handleShowPopupClick={
                            handleShowFavoritePharmaciesPopupClick
                          }
                          handleHidePopupClick={
                            handleHideFavoritePharmaciesPopupClick
                          }
                        >
                          <FavoritePharmacyDataList
                            handlepharmacyCodeRefClick={
                              handlepharmacyCodeRefClick
                            }
                            setPharmacyPopulateId={setPharmacyPopulateId}
                            setPharmacyCodeOptionClass={
                              setPharmacyCodeOptionClass
                            }
                            pharmacyCodeOptionClass={pharmacyCodeOptionClass}
                            formData={formProps.values}
                            handleHidePopupClick={
                              handleHideFavoritePharmaciesPopupClick
                            }
                          />
                        </DialogPopup>
                      </Grid>
                    </LgCardStyle>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <LgCardStyle className="rft rxpad9">
                      <NoteToggleStyle>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={note}
                          onChange={handleNoteChange}
                        >
                          <FormControlLabel
                            value="NotetoPharmacist"
                            control={<Radio />}
                            label="Note to Pharmacist"
                          />
                          <FormControlLabel
                            value="DoctorsNotes"
                            control={<Radio />}
                            label="Doctors Notes"
                          />
                        </RadioGroup>
                      </NoteToggleStyle>
                      <Grid
                        container
                        item
                        xs={12}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        columnSpacing={2}
                        rowSpacing={1}
                      >
                        {note === "NotetoPharmacist" ? (
                          <>
                            <Grid item xs={12} md={12}>
                              <RxPadBox>
                                <DRxTextareaStyle className="h44">
                                  <DRxTextarea
                                    type="textarea"
                                    label={"harmacy Note"}
                                    name="instructions"
                                    id={"pharmacynote"}
                                    placeholder={"Enter Pharmacy Note here"}
                                  />
                                  <Typography variant="body2" color="primary">
                                    (Please DO NOT include SIG information in
                                    'Note to Pharmacist')
                                  </Typography>
                                </DRxTextareaStyle>
                              </RxPadBox>
                            </Grid>{" "}
                          </>
                        ) : (
                          <>
                            <Grid item xs={12} md={12}>
                              <RxPadBox>
                                <DRxTextareaStyle className="h44">
                                  <DRxTextarea
                                    type="textarea"
                                    label={"Doctor Note"}
                                    name="doctorNote"
                                    id={"doctornote"}
                                    placeholder={"Enter Doctor Notes here"}
                                  />
                                  <Typography variant="body2" color="primary">
                                    (Doctor Note is internal purpose. Will not
                                    be shown to pharamcy)
                                  </Typography>
                                </DRxTextareaStyle>
                              </RxPadBox>
                            </Grid>{" "}
                          </>
                        )}
                      </Grid>
                    </LgCardStyle>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <LgCardStyle className="rxpad10">
                      <Grid container spacing={0}>
                        {UserServiceState?.epaEnabled &&
                          formProps?.values?.rxhubPBMUniqueId !==
                            "SELECT_BENEFIT_SOURCE" &&
                          UserServiceState?.rtfRtpbEnabled && (
                            <>
                              <Grid item xs={12} sm={6} md={2}>
                                <SingleConfirmCard>
                                  <YSCheckBox
                                    name="priorAuthorization"
                                    label="EPA"
                                  />
                                  <HtmlTooltip
                                    className="w150"
                                    placement="top"
                                    arrow
                                    title={
                                      <>
                                        <Typography
                                          variant="body2"
                                          component={"div"}
                                          style={{
                                            position: "relative",
                                          }}
                                        >
                                          Please Uncheck if you do not want to
                                          initiate Electronic Prior
                                          Authorization Process
                                        </Typography>
                                      </>
                                    }
                                  >
                                    <IconButton className="tooltip">
                                      <img
                                        src={InfoIcon}
                                        alt="Tooltip"
                                        loading="lazy"
                                      />
                                    </IconButton>
                                  </HtmlTooltip>
                                </SingleConfirmCard>
                              </Grid>{" "}
                            </>
                          )}
                        {UserServiceState?.epaEnabled &&
                          formProps?.values?.rxhubPBMUniqueId !==
                            "SELECT_BENEFIT_SOURCE" &&
                          UserServiceState?.rtfRtpbEnabled && (
                            <>
                              <Grid item xs={12} sm={6} md={3}>
                                <SingleConfirmCard>
                                  <YSCheckBox
                                    name="priorityIndicator"
                                    label="Priority Indicator"
                                  />{" "}
                                  <HtmlTooltip
                                    className="w150"
                                    placement="top"
                                    arrow
                                    title={
                                      <>
                                        <Typography
                                          variant="body2"
                                          component={"div"}
                                          style={{
                                            position: "relative",
                                          }}
                                        >
                                          {" "}
                                          Please Check only when it is to be
                                          processed on urgent basis
                                        </Typography>
                                      </>
                                    }
                                  >
                                    <IconButton className="tooltip">
                                      <img
                                        src={InfoIcon}
                                        alt="Tooltip"
                                        loading="lazy"
                                      />
                                    </IconButton>
                                  </HtmlTooltip>
                                </SingleConfirmCard>
                              </Grid>{" "}
                            </>
                          )}
                        {UserServiceState?.epcsenabled &&
                          formProps?.values?.controlledSubstance &&
                          getEPCSControlSubstance(formProps.values) ===
                            true && (
                            <>
                              <Grid item xs={12} sm={6} md={3}>
                                <SingleConfirmCard>
                                  <YSCheckBox
                                    name="epcsQueued"
                                    label="EPCS Queue"
                                  />
                                  <HtmlTooltip
                                    className="w150"
                                    placement="top"
                                    arrow
                                    title={
                                      <>
                                        <Typography
                                          variant="body2"
                                          component={"div"}
                                          style={{
                                            position: "relative",
                                          }}
                                        >
                                          {" "}
                                          Please check only if you want to EPCS
                                          Queue for 2FA
                                        </Typography>
                                      </>
                                    }
                                  >
                                    <IconButton className="tooltip">
                                      <img
                                        src={InfoIcon}
                                        alt="Tooltip"
                                        loading="lazy"
                                      />
                                    </IconButton>
                                  </HtmlTooltip>
                                </SingleConfirmCard>
                              </Grid>{" "}
                            </>
                          )}
                        <Grid item xs={12} sm={6} md={4}>
                          <SingleConfirmCard>
                            {formProps?.values?.drugId && (
                              <>
                                <YSCheckBox
                                  name="postDatedPrescription"
                                  label="Post Dated Prescription"
                                  onChange={(e: any) => {
                                    formProps.setFieldValue(
                                      "postDatedPrescription",
                                      e.target.checked
                                    );
                                    if (!e.target.checked) {
                                      formProps.setFieldValue(
                                        "postDatedPrescriptionDate",
                                        null
                                      );
                                    }
                                  }}
                                />
                                <HtmlTooltip
                                  className="w150"
                                  placement="top"
                                  arrow
                                  title={
                                    <>
                                      <Typography
                                        variant="body2"
                                        component={"div"}
                                        style={{
                                          position: "relative",
                                        }}
                                      >
                                        {" "}
                                        Please check only if you want to
                                        initiate Post Dated Prescription
                                      </Typography>
                                    </>
                                  }
                                >
                                  <IconButton className="tooltip">
                                    <img
                                      src={InfoIcon}
                                      alt="Tooltip"
                                      loading="lazy"
                                    />
                                  </IconButton>
                                </HtmlTooltip>
                              </>
                            )}
                          </SingleConfirmCard>
                          {formProps.values?.postDatedPrescription && (
                            <SingleConfirmCard>
                              <Grid container xs={12}>
                                <Grid item xs={10}>
                                  <DatePickerField>
                                    <LocalizationProvider
                                      dateAdapter={AdapterDateFns}
                                    >
                                      <DatePicker
                                        minDate={tomorrow}
                                        maxDate={maxDate}
                                        label={"Post Dated Prescription Date"}
                                        inputFormat="MM/dd/yyyy"
                                        value={
                                          formProps.values
                                            .postDatedPrescriptionDate
                                        }
                                        onChange={(e) => {
                                          formProps.setFieldValue(
                                            "postDatedPrescriptionDate",
                                            moment(e).format("YYYY-MM-DD")
                                          );
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            error={
                                              formProps.touched
                                                .postDatedPrescriptionDate &&
                                              Boolean(
                                                formProps.errors
                                                  .postDatedPrescriptionDate
                                              )
                                            }
                                            onBlur={formProps.handleBlur}
                                          />
                                        )}
                                      />
                                    </LocalizationProvider>
                                  </DatePickerField>
                                </Grid>{" "}
                              </Grid>{" "}
                            </SingleConfirmCard>
                          )}
                        </Grid>
                      </Grid>
                    </LgCardStyle>
                  </Grid>
                  <Grid item xs={12}>
                    <BtnGroupStyle className="right rxpad11">
                      <YSButton
                        size="large"
                        className=""
                        color="secondary"
                        dataTestId="submitBtn"
                        variant="outlined"
                        disabled={false}
                        type="reset"
                        children={"Reset"}
                        onClick={(e) => {
                          formProps.setFieldValue("pharmacyCode", null);
                          setDrugDescShow(false);
                          props.resetRxForm(formProps.values);
                        }}
                      />{" "}
                      {tabListLength === formProps.values.rxNumber ? (
                        <YSButton
                          className=""
                          children={"Add New"}
                          size={"large"}
                          type="button"
                          color="primary"
                          variant="outlined"
                          startIcon={<AddCircleOutlineOutlinedIcon />}
                          onClick={(e) => {
                            if (
                              (formProps.values.epcsQueued ||
                                formProps.values.postDatedPrescription) &&
                              [null, ""].includes(
                                PrescriberDetailsState?.AllPrescriberDetails
                                  ?.email
                              )
                            ) {
                              handleShowEmailUpdatePopupClick();
                              if (
                                formProps.values.postDatedPrescription &&
                                !formProps.values.epcsQueued
                              ) {
                                setStateData((prevState: any) => {
                                  return {
                                    ...prevState,
                                    message:
                                      "Email Address is needed to use Post Dated Prescription Functionality",
                                    variant: "error",
                                    open: true,
                                  };
                                });
                              } else if (
                                formProps.values.epcsQueued &&
                                !formProps.values.postDatedPrescription
                              ) {
                                setStateData((prevState: any) => {
                                  return {
                                    ...prevState,
                                    message:
                                      "Email Address is needed to use EPCS queue Functionality",
                                    variant: "error",
                                    open: true,
                                  };
                                });
                              } else if (
                                formProps.values.epcsQueued &&
                                formProps.values.postDatedPrescription
                              ) {
                                setStateData((prevState: any) => {
                                  return {
                                    ...prevState,
                                    message:
                                      "Email Address is needed to use EPCS Queue & Post Dated prescriptions Functionality",
                                    variant: "error",
                                    open: true,
                                  };
                                });
                              }
                            } else {
                              props.newPrescription(
                                formProps.values,
                                formProps.isValid
                              );
                            }
                          }}
                        />
                      ) : (
                        <YSButton
                          className=""
                          onClick={() => {
                            props.saveAndContinue(
                              formProps.values,
                              formProps.isValid
                            );
                          }}
                          type="button"
                          variant="contained"
                          color="primary"
                          children={"Save & Continue"}
                          size="large"
                        />
                      )}
                      <YSButton
                        className=""
                        onClick={null}
                        disabled={
                          UserServiceState?.profileGroup === 11 &&
                          formProps.values.confirmButtondisabled
                            ? true
                            : false
                          // onBehalfContext?.id &&
                          // UserServiceState?.profileGroup !== 11
                          //   ? false
                          //   : UserServiceState?.profileGroup > 9
                          //   ? true
                          //   : false
                        }
                        type="submit"
                        variant="contained"
                        color="primary"
                        startIcon={
                          UserServiceState?.profileGroup === 11 &&
                          formProps.values.confirmButtondisabled ? (
                            <LockIcon />
                          ) : null
                          // onBehalfContext?.id &&
                          // UserServiceState?.profileGroup !== 11
                          //   ? null
                          //   : UserServiceState?.profileGroup > 9 && <LockIcon />
                        }
                        children={
                          props?.submitLoad ? (
                            <CircularProgress size={28} color={"inherit"} />
                          ) : (
                            "Confirm Prescription(s)"
                          )
                        }
                        size="large"
                      />
                    </BtnGroupStyle>
                  </Grid>{" "}
                </Grid>
              </Form>
            );
          }}
        </Formik>
      )}

      {/* Alternatives */}
      <DialogPopup
        windowsize={"md"}
        title={"Alternatives"}
        show={showAlternatives}
        handleShowPopupClick={handleShowAlternativesPopupClick}
        handleHidePopupClick={handleHideAlternativesPopupClick}
      >
        <Grid item xs={12}>
          <Grid container display={"flex"} justifyContent={"space-between"}>
            <Grid item xs={12} md={4}>
              {" "}
              <Typography
                component="span"
                variant="caption"
                marginTop={2}
                marginBottom={2}
                fontWeight={600}
              >
                *- Therapeutical Alternatives
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              {" "}
              <Typography
                component="span"
                variant="caption"
                marginTop={2}
                marginBottom={2}
                fontWeight={600}
              >
                **- Payer/PBM Specified Alternatives
              </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              {" "}
              <Typography
                component="span"
                variant="caption"
                marginTop={2}
                marginBottom={2}
                fontWeight={600}
              >
                G - Generic
              </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              {" "}
              <Typography
                component="span"
                variant="caption"
                marginTop={2}
                marginBottom={2}
                fontWeight={600}
              >
                B - Branded
              </Typography>
            </Grid>
          </Grid>
          <DataGridListStyle>
            <DataGrid
              rows={data?.rtfAlternativeDrugsInfo ?? []}
              sortingOrder={["desc", "asc"]}
              columns={alternativeColumns}
              autoHeight
              rowHeight={60}
              getRowId={(row) => row.code ?? uuid()}
              headerHeight={36}
              pageSize={10}
              disableSelectionOnClick
              autoPageSize
              rowsPerPageOptions={[10]}
              components={{
                NoRowsOverlay: NoRecords,
                NoResultsOverlay: NoRecords,
              }}
            />
          </DataGridListStyle>
        </Grid>
      </DialogPopup>
      {/* Payer PBM */}
      <DialogPopup
        windowsize={"md"}
        title={"Payer/PBM Specified Alternatives"}
        show={showPayerPBMSpecifiedAltPopup}
        handleShowPopupClick={handleShowPayerPBMSpecifiedAltPopupClick}
        handleHidePopupClick={handleHidePayerPBMSpecifiedAltPopupClick}
      >
        <Grid item xs={12}>
          <Grid container display={"flex"} justifyContent={"space-between"}>
            <Grid item xs={12} md={4}>
              {" "}
              <Typography
                component="span"
                variant="caption"
                marginTop={2}
                marginBottom={2}
                fontWeight={600}
              >
                *- Therapeutical Alternatives
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              {" "}
              <Typography
                component="span"
                variant="caption"
                marginTop={2}
                marginBottom={2}
                fontWeight={600}
              >
                **- Payer/PBM Specified Alternatives
              </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              {" "}
              <Typography
                component="span"
                variant="caption"
                marginTop={2}
                marginBottom={2}
                fontWeight={600}
              >
                G - Generic
              </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              {" "}
              <Typography
                component="span"
                variant="caption"
                marginTop={2}
                marginBottom={2}
                fontWeight={600}
              >
                B - Branded
              </Typography>
            </Grid>
          </Grid>
          <DataGridListStyle>
            <DataGrid
              rows={data?.payerAlternativeDrugs ?? []}
              sortingOrder={["desc", "asc"]}
              columns={alternativeColumns}
              autoHeight
              rowHeight={60}
              getRowId={(row) => row.code ?? uuid()}
              headerHeight={36}
              pageSize={10}
              disableSelectionOnClick
              autoPageSize
              rowsPerPageOptions={[10]}
              components={{
                NoRowsOverlay: NoRecords,
                NoResultsOverlay: NoRecords,
              }}
            />
          </DataGridListStyle>
        </Grid>
      </DialogPopup>
      {/* step medication */}
      <DialogPopup
        windowsize={"md"}
        title={"Step Medications"}
        show={showStepMedicationsPopup}
        handleShowPopupClick={handleShowStepMedicationsPopupClick}
        handleHidePopupClick={handleHideStepMedicationsPopupClick}
      >
        <StepMedicationsList
          stepMedicationsList={data?.stepMedicationsList}
          showStepMedicationsPopup
          setStepMedicationsPopup
          handleShowPopupClick={handleShowStepMedicationsPopupClick}
          handleHidePopupClick={handleHideStepMedicationsPopupClick}
        />
      </DialogPopup>
      {/* Therapeutical Alternative */}
      <DialogPopup
        windowsize={"md"}
        title={"Therapeutical Alternatives"}
        show={showTherapeuticalAltPopup}
        handleShowPopupClick={handleShowTherapeuticalAltPopupClick}
        handleHidePopupClick={handleHideTherapeuticalAltPopupClick}
      >
        <Grid item xs={12}>
          <Grid container display={"flex"} justifyContent={"space-between"}>
            <Grid item xs={12} md={4}>
              {" "}
              <Typography
                component="span"
                variant="caption"
                marginTop={2}
                marginBottom={2}
                fontWeight={600}
              >
                *- Therapeutical Alternatives
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              {" "}
              <Typography
                component="span"
                variant="caption"
                marginTop={2}
                marginBottom={2}
                fontWeight={600}
              >
                **- Payer/PBM Specified Alternatives
              </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              {" "}
              <Typography
                component="span"
                variant="caption"
                marginTop={2}
                marginBottom={2}
                fontWeight={600}
              >
                G - Generic
              </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              {" "}
              <Typography
                component="span"
                variant="caption"
                marginTop={2}
                marginBottom={2}
                fontWeight={600}
              >
                B - Branded
              </Typography>
            </Grid>
          </Grid>
          <DataGridListStyle>
            <DataGrid
              rows={data?.therapeuticalAlternativeDrugs ?? []}
              sortingOrder={["desc", "asc"]}
              columns={alternativeColumns}
              autoHeight
              rowHeight={60}
              getRowId={(row) => row.code ?? uuid()}
              headerHeight={36}
              pageSize={10}
              disableSelectionOnClick
              autoPageSize
              rowsPerPageOptions={[10]}
              components={{
                NoRowsOverlay: NoRecords,
                NoResultsOverlay: NoRecords,
              }}
            />
          </DataGridListStyle>
        </Grid>
      </DialogPopup>
      {/* epcs email update  */}
      <DialogPopup
        title={"Update Contact Info"}
        windowsize={"sm"}
        show={emailUpdatePopup}
        handleShowPopupClick={handleShowEmailUpdatePopupClick}
        handleHidePopupClick={handleHideEmailUpdatePopupClick}
      >
        <Formik
          validationSchema={yup.object().shape({
            email: yup.string().email("Invalid email."),
          })}
          initialValues={{ email: "" }}
          onSubmit={(values: any) => {
            updateEmailReminder(values);
          }}
        >
          {(emailProps: any) => (
            <Grid
              container
              item
              xs={12}
              spacing={1}
              alignItems="top"
              justifyContent="center"
            >
              <Grid item xs={12}>
                <Typography
                  color="primary"
                  component="span"
                  variant="body2"
                  fontWeight={600}
                >
                  EPCS Queue & Post Dated prescriptions related notifications
                  will be sent to your mail address. Please let us know your
                  mail to keep you updated.
                </Typography>{" "}
              </Grid>
              <Grid item xs={12}>
                <InputSMBoxStyle>
                  <Typography
                    component="label"
                    variant="body2"
                    htmlFor="lastname"
                  >
                    Email
                  </Typography>{" "}
                  <Box>
                    <DRxInputStyle>
                      <TextField
                        id="email"
                        name="email"
                        type="text"
                        className="input"
                        disabled={false}
                        value={emailProps.values?.email}
                        onChange={emailProps.handleChange}
                      />
                    </DRxInputStyle>
                    <YSButton
                      className={""}
                      children={"Save"}
                      onClick={() => {
                        emailProps.handleSubmit();
                      }}
                      variant={"contained"}
                      size={"large"}
                      style={{ marginTop: 10 }}
                    />
                  </Box>
                </InputSMBoxStyle>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  color="green"
                  component="span"
                  variant="body2"
                  fontWeight={400}
                >
                  Note: Please use a valid email address for EPCS Queue or Post
                  Dated Prescription Alerts to avoid any miss outs on
                  Prescription processing.{" "}
                </Typography>{" "}
              </Grid>
            </Grid>
          )}
        </Formik>
      </DialogPopup>
      <YSSnackBar
        message={StateData.message}
        variant={StateData.variant}
        open={StateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
